import { makeStyles } from "@material-ui/core";
import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";


const useStyles = makeStyles((theme) => ({
  footer: {
    color: "#202020",
    fontSize: "12px",
    padding: "0.5rem",
    marginTop: "1rem",
    bottom: 10,
    left: 0,
    width: "100%",
    textAlign: "center",
    position: "fixed",
  },
  link: {
    color: "#202020",
  },
}));

const Footer = () => {
  const classes = useStyles();
  const brandingProps = useSelector(state => state.login.brandingProps);
  const termsOfUseLink = brandingProps?.termsOfUseLink || "";
  const privacyPolicyLink = brandingProps?.privacyPolicyLink || "";

  return (
    <div className={classes.footer}>
      {brandingProps?.footerText}
      <a
        target="_blank"
        href={termsOfUseLink}
        rel="noreferrer"
        className={classes.link}
      >
        {" "}
        Terms and Conditions{" "}
      </a>{" "}
      and
      <a
        target="_blank"
        href={privacyPolicyLink}
        rel="noreferrer"
        className={classes.link}
      >
        {" "}
        Privacy Policy
      </a>
      .
    </div>
  );
};

export default Footer;
